// extracted by mini-css-extract-plugin
export default {"page":"activate_page__sZguo","goToLogin":"activate_goToLogin__eP3yM"};